var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('pbas-data-table',{ref:"table",attrs:{"dataProvider":_vm.provider,"fileNamePrefix":"payments","identifier":"claim_submission_payments","showSelect":false}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }